export default "__VITE_ASSET__9e9682bf__"